<div
  (dblclick)="onDoubleClick()"
  [style.background-color]="params.value?.value"
></div>
